import React, { memo } from 'react';
import moment from 'moment';

/**
 * Generic table cell for displaying a date/timestamp.
 * @param {string} timestamp - ISO date string or any moment-parseable value.
 * @param {string} [format='MMM D, YYYY'] - moment format string.
 */
const DateCell = memo(({ timestamp = '', format = 'MMM D, YYYY' }) => {
  if (!timestamp) {
    return null;
  }

  return <span>{moment.utc(timestamp).format(format)}</span>;
});

DateCell.displayName = 'DateCell';

export default DateCell;
